import { useMemo } from "react";
import type { Celebrity } from "@pushup/types";
import { useCelebrityStore } from "@/state/celebrity-store";
import { useCelebrities } from "./use-celebrities";

/** The full celebrity object for the locally selected opponent, if any. */
export function useSelectedCelebrity(): Celebrity | null {
  const selectedId = useCelebrityStore((s) => s.selectedCelebrityId);
  const { data: celebrities } = useCelebrities();
  return useMemo(
    () => celebrities?.find((c) => c.id === selectedId) ?? null,
    [celebrities, selectedId],
  );
}
